import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule} from '@angular/router';

//Material Design Css import
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule} from '@angular/material';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule} from '@angular/material/radio';
import { MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
//Material Design Css import


import { AppComponent } from './khb.component';
import { HeaderComponent } from './common/header/header.component';
import { Level1menuComponent } from './common/level1menu/level1menu.component';
import { UltilitiesComponent } from './ultilities/ultilities.component';
import { UltilitiesMenuComponent } from './ultilities/ultilities-menu/ultilities-menu.component';
import { UserComponent } from './ultilities/user/user.component';
import { SettingComponent } from './ultilities/setting/setting.component';
import { SearchbarComponent } from './common/searchbar/searchbar.component';
import { RolesComponent } from './ultilities/roles/roles.component';
import { RolesGridComponent } from './ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './ultilities/roles/roles-form/roles-form.component';
import { UserService } from './shared/user.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './registration/login/login.component';
import { SignupComponent } from './registration/signup/signup.component';
import { UserGridComponent } from './ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './ultilities/user/user-form/user-form.component';
import { ClaimGridComponent } from './ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './ultilities/claims/claims/claim-form/claim-form.component';
import { ClaimsComponent } from './ultilities/claims/claims/claims.component';
import { RegistrationComponent } from './registration/registration.component';
import { ErrorHandler } from './shared/ErrorHandler';
import {NgxPaginationModule} from 'ngx-pagination';
import { appRoutes } from '../route';
import { HomepageComponent } from './homepage/homepage.component';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
import { ForgotPasswordComponent } from './registration/forgot-password/forgot-password.component';

import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { PetitionComponent } from './petition/petition.component';
import { PetitionMenuComponent } from './petition/petition-menu/petition-menu.component';
import { PetitionGridComponent } from './petition/petition-grid/petition-grid.component';
import { PetitionFormComponent } from './petition/petition-form/petition-form.component';
import { PetitionApprovalComponent } from './petition/petition-approval/petition-approval.component';
import { DistrictGridComponent } from './masters/district/district-grid/district-grid.component';

import { DistrictFormComponent } from './masters/district/district-form/district-form.component';
import { DistrictComponent } from './masters/district/district.component';
import { MastersComponent } from './masters/masters.component';
import { MasterMenuComponent } from './masters/master-menu/master-menu.component';
import { BudgetGridComponent } from './finance/budget/budget-grid/budget-grid.component';
import { BudgetFormComponent } from './finance/budget/budget-form/budget-form.component';
import { FinanceComponent } from './finance/finance.component';
import { FinanceMenuComponent } from './finance/finance-menu/finance-menu.component';
import { ExpenditureGridComponent } from './finance/expenditure/expenditure-grid/expenditure-grid.component';
import { ExpenditureFormComponent } from './finance/expenditure/expenditure-form/expenditure-form.component';
import { VehicleGridComponent } from './ultilities/vehicle/vehicle-grid/vehicle-grid.component';
import { VehicleFormComponent } from './ultilities/vehicle/vehicle-form/vehicle-form.component';
import { CasteVerificationComponent } from './caste-verification/caste-verification.component';
import { CasteVerificationMenuComponent } from './caste-verification/caste-verification-menu/caste-verification-menu.component';
import { CasteVerificationGridComponent } from './caste-verification/caste-verification-grid/caste-verification-grid.component';
import { CasteVerificationFormComponent } from './caste-verification/caste-verification-form/caste-verification-form.component';
import { PetitionApprovalGridComponent } from './petition/petition-approval-grid/petition-approval-grid.component';
import { CorrespondanceTrackingComponent } from './correspondance-tracking/correspondance-tracking.component';
import { CtGridComponent } from './correspondance-tracking/ct-grid/ct-grid.component';
import { CtFormComponent } from './correspondance-tracking/ct-form/ct-form.component';
import { CtMenuComponent } from './correspondance-tracking/ct-menu/ct-menu.component';
import { TalukComponent } from './masters/taluk/taluk.component';
import { TalukGridComponent } from './masters/taluk/taluk-grid/taluk-grid.component';
import { TalukFormComponent } from './masters/taluk/taluk-form/taluk-form.component';
import { OfficeGridComponent } from './masters/office/office-grid/office-grid.component';
import { OfficeFormComponent } from './masters/office/office-form/office-form.component';




@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    Level1menuComponent,
    LoginComponent,
    UltilitiesComponent,
    UltilitiesMenuComponent,
    UserComponent,
    SettingComponent,
    SearchbarComponent,
    RolesComponent,
    RolesGridComponent,
    RolesFormComponent,
    SignupComponent,
    UserGridComponent,
    UserFormComponent,
    ClaimGridComponent,
    ClaimFormComponent,
    ClaimsComponent,
    RegistrationComponent,
    HomepageComponent,
    ChangePasswordComponent,
    PetitionComponent,
    PetitionMenuComponent,
    PetitionGridComponent,
    PetitionFormComponent,
    PetitionApprovalComponent,
    DistrictGridComponent,
    
    DistrictFormComponent,
    DistrictComponent,
    MastersComponent,
    MasterMenuComponent,
    BudgetGridComponent,
    BudgetFormComponent,
    FinanceComponent,
    FinanceMenuComponent,
    ExpenditureGridComponent,
    ExpenditureFormComponent,
    VehicleGridComponent,
    VehicleFormComponent,
    CasteVerificationComponent,
    CasteVerificationMenuComponent,
    CasteVerificationGridComponent,
    CasteVerificationFormComponent,
    PetitionApprovalGridComponent,
    CorrespondanceTrackingComponent,
    CtGridComponent,
    CtFormComponent,
    CtMenuComponent,
    TalukComponent,
    TalukGridComponent,
    TalukFormComponent,
    OfficeGridComponent,
    OfficeFormComponent    
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule, MatCheckboxModule,MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule, 
    MatNativeDateModule,
    MatCheckboxModule,
    MatSelectModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [UserService, ErrorHandler,AuthGuard,{provide: LocationStrategy, useClass: HashLocationStrategy},
  // {
  //   provide: HTTP_INTERCEPTORS,
  //   useClass:AuthInterceptor,
  //   multi:true
  // }
],
  bootstrap: [AppComponent]
})
export class AppModule { } 



// WEBPACK FOOTER //
// ./src/app/khb.module.ts